import { render, staticRenderFns } from "./reviewModal.vue?vue&type=template&id=23955fd6&scoped=true&"
import script from "./reviewModal.vue?vue&type=script&lang=ts&"
export * from "./reviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./reviewModal.vue?vue&type=style&index=0&id=23955fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23955fd6",
  null
  
)

export default component.exports